export default __webpack_public_path__ + "static/media/clock_content.04b57d72.svg";